const VERSION_STORAGE_KEY = 'app-version';

let _version: string | null = localStorage.getItem(VERSION_STORAGE_KEY);

export const versionStorage = {
  isInitialized(): boolean {
    return _version !== null;
  },

  get(): string | null {
    return _version;
  },

  set(version: string): void {
    _version = version;
    localStorage.setItem(VERSION_STORAGE_KEY, version);
  },
};
